module.exports = __webpack_public_path__ + "img/OverseaMember12.09c381e9.jpg";